import { useSeriesNav } from 'hooks/commonGame/useSeriesNav';

import { USE_VERY_SPARINGLY_HideAndroidNavigationBar } from '../USE_VERY_SPARINGLY_HideAndroidNavigationBar';

// Call useHideAndroidNavigationBar() hook unless it's already done on app navigation level
// packages/core/src/components/navigation/AppNavigation/index.tsx:161
// Avoid calling the hook twice as it causes unexpected behavior with unmount logic
export const EnsureAndroidNavigationBarHidden = () => {
  const seriesNav = useSeriesNav();
  if (seriesNav) {
    <USE_VERY_SPARINGLY_HideAndroidNavigationBar />;
  }
  return null;
};
